import React, { ReactElement } from 'react'
import Thumbnail from '@bit/atd.web.thumbnail'
import { makeStyles } from '@material-ui/core/styles'
import colors from '@bit/atd.web.colors'
import parse from 'html-react-parser'
import dompurify from 'dompurify'
import Grid from '@bit/atd.web.grid'

const useStyles = makeStyles({
  categorizedWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: '8px',
    '&:first-child': {
      marginTop: '20px',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  categorizedThumbnail: {
    // width: '42px',
    //height: '42px',
    // width: '42px',
    //paddingBottom: 0,
    '& img': {
      // objectFit: 'contain',
    },
  },
  categorizedText: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '18px',
    color: colors.ctaSecondaryDarker,
  },
  textHighlighted: {
    '& em': {
      fontWeight: 600,
      color: colors.ctaPrimary,
      background: 'transparent',
    },
  },
})

type PropTypes = {
  title: string
  imageUrl: string
  url: string
  objectID: string
  category: string
}

const CategorisedRow = (props: PropTypes): ReactElement => {
  const { title, imageUrl: src, url, category } = props
  const classes = useStyles()
  let ratio = '1:1'
  let resize

  switch (category) {
    case 'publications': // we should rename this to correct aspect ratio
      resize = 'w=74&h=100'
      ratio = '2:3'
      break
    case 'conferences': // we should rename this to correct aspect ratio
      resize = 'w=100&h=74'
      ratio = '3:2'
      break
    default:
    case 'courses': // we should rename this to correct aspect ratio
      resize = 'w=100&h=100'
      ratio = '1:1'
      break
  }

  // @todo move this to backend URL prep
  const newSrc = `${src
    ?.replace('https://d22bbllmj4tvv8.cloudfront.net', 'https://atd.imgix.net')
    .replace(
      'http://files.astd.org.s3.amazonaws.com',
      'https://atd-s3.imgix.net',
    )
    .replace(
      'https://atd-brightspot-lower.s3.amazonaws.com',
      'https://atd-brightspot-lower.imgix.net',
      // )}?${resize}&fit=crop`
    )}?${resize}`

  return (
    <Grid
      container
      spacing={2}
      className={classes.categorizedWrapper}
      onClick={() => window.location.assign(url)}
    >
      <Grid item xs={2}>
        <Thumbnail
          className={classes.categorizedThumbnail}
          src={newSrc}
          // @ts-ignore
          ratio={ratio}
        />
      </Grid>
      <Grid item xs={10}>
        <span className={classes.categorizedText}>
          {parse(
            dompurify.sanitize(
              `<span class="${classes.textHighlighted}">${title}</span>`,
            ),
          )}
        </span>
      </Grid>
    </Grid>
  )
}

export default CategorisedRow
